<template>
    <nav @click.stop class="lc-sidebar sidebar">
        <header class="sidebar__header">
            <button @click="close" class="icon-button">
                <icon type="close" color="bluegray" size="20" />
            </button>
            <p class="lc-company sidebar__channel">{{ tenant.display_name }}</p>
        </header>
        <div class="sidebar__content">
            <nav class="lc-channels channels-navigation">
                <p class="channels-navigation__add">
                    Channels
                </p>
                <a v-for="channel in channels"
                   :key="channel.id"
                   :href="channel.url"
                   class="lc-channel-item channels-navigation__item" :class="{ 'active' : current && current.id === channel.id, 'bold' : hasNotification(channel.id) }"
                >
                    <span v-cloak>{{ channel.name }}</span>
                </a>
                <a v-if="currentUser.is_not_guest" @click.prevent="createChannel" class="add_channel_button">
                    Add Channel <icon type="plus" color="blue" size="14" />
                </a>
            </nav>
        </div>
    </nav>
</template>

<script>
/* global Echo */
import collect from 'collect.js'
import { mapGetters, mapState, mapMutations } from 'vuex'
import { CLOSE_SIDEBAR, RECEIVE_CHANNEL, OPEN_CHANNEL_CREATION } from '../../stores/global/mutations'
import Icon from '../../components/Global/Icon'

export default {
    components: {
        Icon
    },

    props: {
        tenant: {
            type: Object,
            required: true
        }
    },

    created () {
        Echo.channel('skybase')
            .listen('ChannelWasCreated', (e) => {
                this.$store.commit(RECEIVE_CHANNEL, (e.channel))
            })
            .listen('ChannelWasUpdated', (e) => {
                this.$store.commit(RECEIVE_CHANNEL, (e.channel))
            })
    },

    methods: {
        ...mapMutations({
            close: CLOSE_SIDEBAR
        }),

        // TODO: Have the API return `channel.notification_count` to save this on the client side.
        hasNotification (channelId) {
            return collect(this.notifications).where('channel_id', channelId).count() > 0
        },

        createChannel () {
            this.$store.commit(OPEN_CHANNEL_CREATION)
            this.close()
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapState('notifications', ['notifications']),

        ...mapGetters({
            current: 'currentChannel',
            channels: 'activeCurrentUserChannels'
        })
    }
}
</script>
